import * as types from "./types";
import JigsawAPI from "../../services/jigsaw";
import { normalize, schema } from "../normalize";

const markerSchema = new schema.Entity(
  "markers",
  {},
  { idAttribute: "globalId" }
);

const markerListSchema = new schema.Array(markerSchema);

const defaultMarkerEntities = {
  markers: {}
};

const fetchMarkersRequest = () => ({
  type: types.FETCH_MARKERS_REQUEST
});

const fetchMarkersSuccess = (data, colorOptions) => ({
  type: types.FETCH_MARKERS_SUCCESS,
  data,
  colorOptions
});

const fetchMarkersFailure = error => ({
  type: types.FETCH_MARKERS_FAILURE,
  error
});

export const fetchMarkers = () => async dispatch => {
  dispatch(fetchMarkersRequest());
  return JigsawAPI.User.getMarkers()
    .then(({ colorOptions, markers }) => {
      const n = normalize;
      const ms = markerSchema;
      dispatch(
        fetchMarkersSuccess(
          normalize(markers, markerListSchema, defaultMarkerEntities),
          colorOptions
        )
      );
    })
    .catch(error => dispatch(fetchMarkersFailure(error)));
};

const fetchMarkerRequest = globalId => ({
  type: types.FETCH_MARKER_REQUEST,
  globalId
});

const fetchMarkerSuccess = (globalId, data) => ({
  type: types.FETCH_MARKER_SUCCESS,
  globalId,
  data
});

const fetchMarkerFailure = (globalId, error) => ({
  type: types.FETCH_MARKER_FAILURE,
  globalId,
  error
});

export const fetchMarker = globalId => async dispatch => {
  dispatch(fetchMarkerRequest(globalId));
  return JigsawAPI.User.getMarkers()
    .then(({ marker }) =>
      dispatch(
        fetchMarkerSuccess(
          globalId,
          normalize(marker, markerSchema, defaultMarkerEntities)
        )
      )
    )
    .catch(error => dispatch(fetchMarkerFailure(globalId, error)));
};

const updateMarkerRequest = (globalId, data) => ({
  type: types.UPDATE_MARKER_REQUEST,
  globalId,
  data
});

export const updateMarkerSuccess = (globalId, data) => ({
  type: types.UPDATE_MARKER_SUCCESS,
  globalId,
  data
});

const updateMarkerFailure = (globalId, error, oldData) => ({
  type: types.UPDATE_MARKER_FAILURE,
  globalId,
  data: oldData, // TODO is this normalized?
  error
});

export const updateMarker = (marker, data) => async dispatch => {
  const globalId = marker.globalId;
  dispatch(updateMarkerRequest(globalId, data));
  return JigsawAPI.User.updateMarker(globalId, data)
    .then(marker => {
      dispatch(
        updateMarkerSuccess(
          globalId,
          normalize(marker, markerSchema, defaultMarkerEntities)
        )
      );
    })
    .catch(error =>
      dispatch(updateMarkerFailure(marker.globalId, error, marker))
    );
};

const deleteMarkerRequest = globalId => ({
  type: types.DELETE_MARKER_REQUEST,
  globalId
});

const deleteMarkerSuccess = globalId => ({
  type: types.DELETE_MARKER_SUCCESS,
  globalId
});

const deleteMarkerFailure = (globalId, error) => ({
  type: types.DELETE_MARKER_FAILURE,
  globalId,
  error
});

export const deleteMarker = globalId => async dispatch => {
  dispatch(deleteMarkerRequest(globalId));
  return JigsawAPI.User.deleteMarker({ id: globalId })
    .then(() => dispatch(deleteMarkerSuccess(globalId)))
    .catch(error => dispatch(deleteMarkerFailure(globalId, error)));
};

const createMarkerRequest = () => ({
  type: types.CREATE_MARKER_REQUEST
});

const createMarkerSuccess = data => ({
  type: types.CREATE_MARKER_SUCCESS,
  data
});

const createMarkerFailure = error => ({
  type: types.CREATE_MARKER_FAILURE,
  error
});

export const createMarker = params => async dispatch => {
  dispatch(createMarkerRequest());
  return JigsawAPI.User.createMarker(params)
    .then(marker =>
      dispatch(
        createMarkerSuccess(
          normalize(marker, markerSchema, defaultMarkerEntities)
        )
      )
    )
    .catch(error => dispatch(createMarkerFailure(error)));
};

export const deleteAndMergeMarkerRequest = (globalId, mergeWith) => ({
  type: types.DELETE_AND_MERGE_MARKER_REQUEST,
  globalId,
  mergeWith
});

export const deleteAndMergeMarkerSuccess = (globalId, mergeWith) => ({
  type: types.DELETE_AND_MERGE_MARKER_SUCCESS,
  globalId,
  mergeWith
});

export const deleteAndMergeMarkerFailure = (error, globalId, mergeWith) => ({
  type: types.DELETE_AND_MERGE_MARKER_FAILURE,
  error,
  globalId,
  mergeWith
});

export const deleteAndMergeMarker = (globalId, mergeWith) => async dispatch => {
  dispatch(deleteAndMergeMarkerRequest(globalId, mergeWith));
  return JigsawAPI.User.deleteMarker({ id: globalId, mergeWith })
    .then(() => dispatch(deleteAndMergeMarkerSuccess(globalId, mergeWith)))
    .catch(error =>
      dispatch(deleteAndMergeMarkerFailure(error, globalId, mergeWith))
    );
};

export const internal = {
  fetchMarkersRequest,
  fetchMarkersSuccess,
  fetchMarkersFailure,
  fetchMarkerRequest,
  fetchMarkerSuccess,
  fetchMarkerFailure,
  updateMarkerRequest,
  updateMarkerSuccess,
  updateMarkerFailure,
  createMarkerRequest,
  createMarkerSuccess,
  createMarkerFailure,
  deleteMarkerRequest,
  deleteMarkerSuccess,
  deleteMarkerFailure,
  deleteAndMergeMarkerRequest,
  deleteAndMergeMarkerSuccess,
  deleteAndMergeMarkerFailure
};
